// Logo URL for SizzleBox
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_food-order-hub-89/artifacts/aau6a4ky_WhatsApp_Image_2026-03-23_at_16.47.55-removebg-preview.png";

// Logo component
export function Logo({ className = "h-10" }) {
  return (
    <img 
      src={LOGO_URL} 
      alt="SizzleBox" 
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
}

// Text logo as fallback
export function TextLogo({ className = "" }) {
  return (
    <span className={`font-heading text-2xl text-white ${className}`}>
      <span className="text-fire-500">Sizzle</span>box
    </span>
  );
}
